require('./uploadImageButton.scss');

// @ vendor
const classNames = require('classnames');
const { includes } = require('lodash/collection');
const PropTypes = require('prop-types');
const React = require('react');
// @ commons
const { FormattedText } = require('core/i18n').i18n;
const { OKButton } = require('components/commons/OKButton/OKButton');
// @ constants
const { PROFILE_AVATAR_IMAGE_MAXIMUM_SIZE_MB } = require('constants/index');

class UploadImageButton extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            errorImageType: false,
            errorImageSize: false
        };
        this.handleDropImage = this.handleDropImage.bind(this);
        this.handleUploadPicture = this.handleUploadPicture.bind(this);
        this.setErrorState = this.setErrorState.bind(this);
        this.uploadImage = this.uploadImage.bind(this);
    }

    setErrorState(errorImageSize, errorImageType) {
        const { setProfileAvatarEditorError } = this.props;
        this.setState({
            errorImageSize,
            errorImageType
        });
        setProfileAvatarEditorError(errorImageSize || errorImageType);
    }

    handleDropImage(evt) {
        let files;
        evt.preventDefault();

        if (evt.dataTransfer) {
            files = evt.dataTransfer.files;
        } else if (evt.target) {
            files = evt.target.files;
        }

        this.uploadImage(files[0]);

        evt.target.value=null;
    }

    handleUploadPicture() {
        const uploadImageButton = this.onClickUploadPicture;
        uploadImageButton.click();
    }

    isValidFileExtension(file) {
        const imageType = file.type.split('/')[1];
        const validImageTypes = [
            'jpg',
            'jpeg',
            'png',
            'bmp',
            'gif'
        ];

        return includes(validImageTypes, imageType);
    }

    // tests if file can be loaded as image in the browser to avoid the upload of files with changed extension
    // for example if you have a .exe file and change it to .jpg
    isValidImageFile(imageUrl) {
        return new Promise (resolve => {
            let image = new Image();
            image.addEventListener("load", () => {
                resolve(true);
            });
            image.addEventListener("error", () => {
                resolve(false);
            });
            image.src = imageUrl;
        });
    }

    isValidImageSize(file) {
        // Convert file size from B to MB
        const size = file.size/(1024*1024);

        return size <= PROFILE_AVATAR_IMAGE_MAXIMUM_SIZE_MB;
    }

    uploadImage(file) {
        const { setImageUrl } = this.props;
        const reader = new FileReader();

        reader.onloadend = (evt) => {
            const imageUrl = evt.target.result;
            const sizeOK = this.isValidImageSize(file);
            this.isValidImageFile(imageUrl).then(isImageFile => {
                const typeOK = isImageFile && this.isValidFileExtension(file);
                this.setErrorState(!sizeOK, !typeOK);
                sizeOK && typeOK && setImageUrl(imageUrl);
            });
        };
        reader.readAsDataURL(file);
    }

    render() {
        const {
            errorImageSize,
            errorImageType
        } = this.state;
        const { label } = this.props;
        const handleOnClickUploadPicture = (uploadPicture) => {
            this.onClickUploadPicture = uploadPicture;
        };

        const errorImageSizeClassNames = classNames(
            'upload-image-button__text-error',
            { 'upload-image-button__text-error--hidden': !errorImageSize || errorImageType }
        );

        const errorImageTypeClassNames = classNames(
            'upload-image-button__text-error',
            { 'upload-image-button__text-error--hidden': !errorImageType }
        );

        return (
            <div>
                <span>
                    <input
                        className="hide"
                        type="file"
                        ref={handleOnClickUploadPicture}
                        onChange={this.handleDropImage}
                    />
                    <OKButton onClick={this.handleUploadPicture} modifier="ghost" leftIcon="icon-subir-imagen" size="regular" block={true}>
                        <FormattedText value={label}/>
                    </OKButton>
                    <div className="upload-image-button__warning-label">
                        <FormattedText value="avatarPicker-imgWarningLabel"/>
                    </div>
                </span>

                <p className={errorImageSizeClassNames}>
                    <i className="icon-error upload-image-button__icon-error"></i>
                    <FormattedText
                        className="upload-image-button__text-error-message"
                        value="avatarPicker-imgErrorSizeFileLabel"
                    />
                </p>
                <p className={errorImageTypeClassNames}>
                    <FormattedText value="avatarPicker-imgErrorTypeFileLabel"/>
                </p>
            </div>
        );
    }
}

UploadImageButton.propTypes = {
    label: PropTypes.string,
    setImageUrl: PropTypes.func,
    setProfileAvatarEditorError: PropTypes.func
};

module.exports = UploadImageButton;
